import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import router from '@/_router';
import { EditStoryMapSlug } from '../../../api/commands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeStorymapSlug extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangeStorymapSlug';
    public _slug: string;

    public constructor(public slug: string) {
        super(ChangeStorymapSlug.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeStorymapSlug): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new EditStoryMapSlug(state.id, action.slug),
        onSuccess: res => action._slug = res.Slug
    });
};

const changeUrlMiddleware = async (state: StorymapState, action: ChangeStorymapSlug): Promise<boolean> => {
    router.replace("/storymap/" + action._slug);
    return true;
};

const reducer = (state: StorymapState, action: ChangeStorymapSlug): void => {
    state.slug = action._slug;
};

//@ts-ignore
registerMiddleware(ChangeStorymapSlug.ACTION_TYPE, middleware);
//@ts-ignore
registerMiddleware(ChangeStorymapSlug.ACTION_TYPE, changeUrlMiddleware);

//@ts-ignore
registerReducer(ChangeStorymapSlug.ACTION_TYPE, reducer);
